export default {
    mapLandmarkCreateEditLandmarkGroup_editTitle: "Edit Landmark Group: ",
    mapLandmarkCreateEditLandmarkGroup_createTitle: "Create New Landmark Group",
    mapLandmarkCreateEditLandmarkGroup_name: "Name",
    mapLandmarkCreateEditLandmarkGroup_landmarkIcon: "Landmark Group Icon",
    mapLandmarkCreateEditLandmarkGroup_success: "Landmark group saved successfully",
    mapLandmarkCreateEditLandmarkGroup_iconRequired: 'You must select an icon or disable "Landmark Group Icon" toggle, please try again',
    mapLandmarkCreateEditLandmarkGroup_groupAlreadyExists: "A group already exists with the name entered"
};